export default __webpack_public_path__ + "static/media/traffic-jam.e172f039.svg";